// extracted by mini-css-extract-plugin
export default {"pageItem":"Pagination_pageItem__NtnyL","active":"Pagination_active__q3h4d","done":"Pagination_done__uWtPW"};